﻿
import {
    trigger,
    style,
    animate,
    transition,
    state,
    keyframes,
    group
} from '@angular/animations';

const animationDuration = 250;

export const idleListenerAnimatedModal = trigger('idleListenerAnimatedModal', [
    state('out, void', style({
        opacity: 0.5,
        transform: 'scale(0.75)'
    })),
    state('in', style({
        opacity: 1,
        transform: 'scale(1)'
    })),
    transition('void <=> *', [
        animate(`${animationDuration}ms ease-in`)
    ])
]);
